import { memo } from 'react';
import { useSelector } from 'react-redux';

import { PublicAssetVersionChip } from '~/components/AssetModalV2/Header/components/PublicAssetVersionChip';
import { centralizedDisplayTitleSelector } from '~/store/centralizedClip/selectors';

/**
 * The asset title shown inside the public asset modal's breadcrumb trail: the centralized clip's
 * display title with the public version chip beside it. Every public surface's trail (board link,
 * collection page, standalone clip link) ends in this same content — only the crumbs BEFORE the
 * title differ per surface.
 */
export const PublicAssetTitleBreadcrumbContent = memo(() => {
  const title = useSelector(centralizedDisplayTitleSelector);

  return (
    <span className="flex min-w-0 items-center gap-1">
      <span className="truncate">{title}</span>
      <PublicAssetVersionChip />
    </span>
  );
});

PublicAssetTitleBreadcrumbContent.displayName = 'PublicAssetTitleBreadcrumbContent';
